import { c as _c } from "react/compiler-runtime";
import type { CustomerKycChoice, CustomerKycField } from '@morfi/onramp-sdk';
import { useTranslations } from 'next-intl';
export function useFundingKycLabels() {
  const $ = _c(155);
  const t = useTranslations("onramp");
  let t0;
  if ($[0] !== t) {
    t0 = t("kyc_first_name");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("kyc_last_name");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("kyc_birth_date");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("kyc_nationality");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("kyc_street");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("kyc_city");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("kyc_postal_code");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("kyc_country");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("kyc_region");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("kyc_ssn");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("kyc_cpf");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("kyc_tin");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("kyc_tin_country");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t("kyc_reporting_country");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t) {
    t14 = t("kyc_reporting_currency");
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t("kyc_employment_status");
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t) {
    t16 = t("kyc_account_purpose");
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t) {
    t17 = t("kyc_annual_income");
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = t("kyc_source_of_wealth");
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t) {
    t19 = t("kyc_monthly_frequency");
    $[38] = t;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t) {
    t20 = t("kyc_monthly_amount");
    $[40] = t;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t) {
    t21 = t("kyc_profession");
    $[42] = t;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t) {
    t22 = t("kyc_net_worth");
    $[44] = t;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t0 || $[47] !== t1 || $[48] !== t10 || $[49] !== t11 || $[50] !== t12 || $[51] !== t13 || $[52] !== t14 || $[53] !== t15 || $[54] !== t16 || $[55] !== t17 || $[56] !== t18 || $[57] !== t19 || $[58] !== t2 || $[59] !== t20 || $[60] !== t21 || $[61] !== t22 || $[62] !== t3 || $[63] !== t4 || $[64] !== t5 || $[65] !== t6 || $[66] !== t7 || $[67] !== t8 || $[68] !== t9) {
    t23 = {
      firstName: t0,
      lastName: t1,
      dateOfBirth: t2,
      nationality: t3,
      street: t4,
      locality: t5,
      postalCode: t6,
      country: t7,
      administrativeArea: t8,
      ssn: t9,
      cpf: t10,
      tin: t11,
      tinCountry: t12,
      reportingCountry: t13,
      reportingCurrency: t14,
      employmentStatus: t15,
      accountPurpose: t16,
      grossAnnualIncome: t17,
      sourceOfWealth: t18,
      transactionFrequencyPerMonth: t19,
      expectedTransactionAmountPerMonth: t20,
      profession: t21,
      netWorth: t22
    };
    $[46] = t0;
    $[47] = t1;
    $[48] = t10;
    $[49] = t11;
    $[50] = t12;
    $[51] = t13;
    $[52] = t14;
    $[53] = t15;
    $[54] = t16;
    $[55] = t17;
    $[56] = t18;
    $[57] = t19;
    $[58] = t2;
    $[59] = t20;
    $[60] = t21;
    $[61] = t22;
    $[62] = t3;
    $[63] = t4;
    $[64] = t5;
    $[65] = t6;
    $[66] = t7;
    $[67] = t8;
    $[68] = t9;
    $[69] = t23;
  } else {
    t23 = $[69];
  }
  let t24;
  if ($[70] !== t) {
    t24 = t("kyc_option_employed_or_self_employed");
    $[70] = t;
    $[71] = t24;
  } else {
    t24 = $[71];
  }
  let t25;
  if ($[72] !== t) {
    t25 = t("kyc_option_retired");
    $[72] = t;
    $[73] = t25;
  } else {
    t25 = $[73];
  }
  let t26;
  if ($[74] !== t) {
    t26 = t("kyc_option_student");
    $[74] = t;
    $[75] = t26;
  } else {
    t26 = $[75];
  }
  let t27;
  if ($[76] !== t) {
    t27 = t("kyc_option_unemployed");
    $[76] = t;
    $[77] = t27;
  } else {
    t27 = $[77];
  }
  let t28;
  if ($[78] !== t) {
    t28 = t("kyc_option_investing");
    $[78] = t;
    $[79] = t28;
  } else {
    t28 = $[79];
  }
  let t29;
  if ($[80] !== t) {
    t29 = t("kyc_option_payments");
    $[80] = t;
    $[81] = t29;
  } else {
    t29 = $[81];
  }
  let t30;
  if ($[82] !== t) {
    t30 = t("kyc_option_purchasing_digital_assets");
    $[82] = t;
    $[83] = t30;
  } else {
    t30 = $[83];
  }
  let t31;
  if ($[84] !== t) {
    t31 = t("kyc_option_purchasing_goods_or_services");
    $[84] = t;
    $[85] = t31;
  } else {
    t31 = $[85];
  }
  let t32;
  if ($[86] !== t) {
    t32 = t("kyc_option_trading");
    $[86] = t;
    $[87] = t32;
  } else {
    t32 = $[87];
  }
  let t33;
  if ($[88] !== t) {
    t33 = t("kyc_option_salary");
    $[88] = t;
    $[89] = t33;
  } else {
    t33 = $[89];
  }
  let t34;
  if ($[90] !== t) {
    t34 = t("kyc_option_savings");
    $[90] = t;
    $[91] = t34;
  } else {
    t34 = $[91];
  }
  let t35;
  if ($[92] !== t) {
    t35 = t("kyc_option_investments");
    $[92] = t;
    $[93] = t35;
  } else {
    t35 = $[93];
  }
  let t36;
  if ($[94] !== t) {
    t36 = t("kyc_option_crypto_trading");
    $[94] = t;
    $[95] = t36;
  } else {
    t36 = $[95];
  }
  let t37;
  if ($[96] !== t) {
    t37 = t("kyc_option_other");
    $[96] = t;
    $[97] = t37;
  } else {
    t37 = $[97];
  }
  let t38;
  if ($[98] !== t) {
    t38 = t("kyc_option_agriculture");
    $[98] = t;
    $[99] = t38;
  } else {
    t38 = $[99];
  }
  let t39;
  if ($[100] !== t) {
    t39 = t("kyc_option_arts_and_entertainment");
    $[100] = t;
    $[101] = t39;
  } else {
    t39 = $[101];
  }
  let t40;
  if ($[102] !== t) {
    t40 = t("kyc_option_business_owner");
    $[102] = t;
    $[103] = t40;
  } else {
    t40 = $[103];
  }
  let t41;
  if ($[104] !== t) {
    t41 = t("kyc_option_education");
    $[104] = t;
    $[105] = t41;
  } else {
    t41 = $[105];
  }
  let t42;
  if ($[106] !== t) {
    t42 = t("kyc_option_financial_services");
    $[106] = t;
    $[107] = t42;
  } else {
    t42 = $[107];
  }
  let t43;
  if ($[108] !== t) {
    t43 = t("kyc_option_healthcare");
    $[108] = t;
    $[109] = t43;
  } else {
    t43 = $[109];
  }
  let t44;
  if ($[110] !== t) {
    t44 = t("kyc_option_industrial_trades_and_transport");
    $[110] = t;
    $[111] = t44;
  } else {
    t44 = $[111];
  }
  let t45;
  if ($[112] !== t) {
    t45 = t("kyc_option_information_and_technology");
    $[112] = t;
    $[113] = t45;
  } else {
    t45 = $[113];
  }
  let t46;
  if ($[114] !== t) {
    t46 = t("kyc_option_legal_and_professional_services");
    $[114] = t;
    $[115] = t46;
  } else {
    t46 = $[115];
  }
  let t47;
  if ($[116] !== t) {
    t47 = t("kyc_option_public_sector");
    $[116] = t;
    $[117] = t47;
  } else {
    t47 = $[117];
  }
  let t48;
  if ($[118] !== t) {
    t48 = t("kyc_option_real_estate");
    $[118] = t;
    $[119] = t48;
  } else {
    t48 = $[119];
  }
  let t49;
  if ($[120] !== t) {
    t49 = t("kyc_option_retail");
    $[120] = t;
    $[121] = t49;
  } else {
    t49 = $[121];
  }
  let t50;
  if ($[122] !== t) {
    t50 = t("kyc_option_senior_management");
    $[122] = t;
    $[123] = t50;
  } else {
    t50 = $[123];
  }
  let t51;
  if ($[124] !== t24 || $[125] !== t25 || $[126] !== t26 || $[127] !== t27 || $[128] !== t28 || $[129] !== t29 || $[130] !== t30 || $[131] !== t31 || $[132] !== t32 || $[133] !== t33 || $[134] !== t34 || $[135] !== t35 || $[136] !== t36 || $[137] !== t37 || $[138] !== t38 || $[139] !== t39 || $[140] !== t40 || $[141] !== t41 || $[142] !== t42 || $[143] !== t43 || $[144] !== t44 || $[145] !== t45 || $[146] !== t46 || $[147] !== t47 || $[148] !== t48 || $[149] !== t49 || $[150] !== t50) {
    t51 = {
      AUD: "AUD",
      EUR: "EUR",
      GBP: "GBP",
      USD: "USD",
      employedOrSelfEmployed: t24,
      retired: t25,
      student: t26,
      unemployed: t27,
      investing: t28,
      payments: t29,
      purchasingDigitalAssets: t30,
      purchasingGoodsOrServices: t31,
      trading: t32,
      salary: t33,
      savings: t34,
      investments: t35,
      cryptoTrading: t36,
      other: t37,
      agriculture: t38,
      artsAndEntertainment: t39,
      businessOwner: t40,
      education: t41,
      financialServices: t42,
      healthcare: t43,
      industrialTradesAndTransport: t44,
      informationAndTechnology: t45,
      legalAndProfessionalServices: t46,
      publicSector: t47,
      realEstate: t48,
      retail: t49,
      seniorManagement: t50
    };
    $[124] = t24;
    $[125] = t25;
    $[126] = t26;
    $[127] = t27;
    $[128] = t28;
    $[129] = t29;
    $[130] = t30;
    $[131] = t31;
    $[132] = t32;
    $[133] = t33;
    $[134] = t34;
    $[135] = t35;
    $[136] = t36;
    $[137] = t37;
    $[138] = t38;
    $[139] = t39;
    $[140] = t40;
    $[141] = t41;
    $[142] = t42;
    $[143] = t43;
    $[144] = t44;
    $[145] = t45;
    $[146] = t46;
    $[147] = t47;
    $[148] = t48;
    $[149] = t49;
    $[150] = t50;
    $[151] = t51;
  } else {
    t51 = $[151];
  }
  let t52;
  if ($[152] !== t23 || $[153] !== t51) {
    t52 = {
      fields: t23,
      choices: t51
    };
    $[152] = t23;
    $[153] = t51;
    $[154] = t52;
  } else {
    t52 = $[154];
  }
  return t52;
}